import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_otherApps.css'
import sites from '../../../../shared/constants/sites'

import fitnessLogo from 'images/sites/fitness/logo.svg'
import walkLogo from 'images/sites/walk/logo.svg'
import runLogo from 'images/sites/run/logo.svg'
import rideLogo from 'images/sites/ride/logo.svg'
import hikeLogo from 'images/sites/hike/logo.svg'
const logos = {
  run: runLogo,
  fitness: fitnessLogo,
  ride: rideLogo,
  walk: walkLogo,
  hike: hikeLogo,
}

import fitnessSplash from 'images/app-page/other-apps/fitness.png'
import runSplash from 'images/app-page/other-apps/run.png'
import rideSplash from 'images/app-page/other-apps/ride.png'
import walkSplash from 'images/app-page/other-apps/walk.png'
import hikeSplash from 'images/app-page/other-apps/hike.png'

const splashes = {
  run: runSplash,
  fitness: fitnessSplash,
  ride: rideSplash,
  walk: walkSplash,
  hike: hikeSplash,
}

function OtherApps (props) {
  const { slug } = props.site
  const currentApp = ['ride', 'run', 'walk', 'hike'].includes(slug) ? slug : 'fitness'
  const appList = ['fitness', 'run', 'ride', 'walk', 'hike']
  const showApps = appList.filter(app => app !== currentApp)
  const apps = showApps.map(app => <App key={app} slug={app} />)

  return (
    <div className={styles.otherApps}>
      <div className={styles.content}>
        <Title align='center'>
          <FormattedMessage id='appPage.otherApps.title' defaultMessage='Other UA Fitness Apps' />
        </Title>
        <Caption align='center'>
          <FormattedMessage
            id='appPage.otherApps.caption'
            defaultMessage='No matter how you stay fit, we have the app to help.'
          />
        </Caption>
      </div>
      <ul className={styles.apps}>{apps}</ul>
    </div>
  )
}

function App (props) {
  const { slug } = props
  const link = (sites.find(site => site.key === slug) || {}).canonical

  return (
    <li className={styles.app}>
      <a href={link}>
        <div className={styles.logo}>
          <img src={logos[slug]} />
        </div>
        <div className={styles.splash}>
          <img src={splashes[slug]} />
        </div>
      </a>
    </li>
  )
}

App.propTypes = {
  slug: PropTypes.string,
}

OtherApps.propTypes = {
  site: PropTypes.object,
}

export default OtherApps
